import React from 'react';
import Button from '../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import TestAnniversaryModal from './TestAnniversaryModal';
import SendNoticeModal from './SendNoticeModal';
import useMode from '../../hooks/useMode';
import { IdArrayInput } from '../../hooks/useTablePages';
import AddAssemblyJobsModal from '../../components/BackflowAssembly/AddAssemblyJobsModal';
import useSessionInfo from '../../hooks/useSessionInfo';
import { PREMIUM_COMPANY_IDS } from '../../constants';

type AssembliesActionsProps = { selectedIds: IdArrayInput };

const AssembliesActions: React.FC<AssembliesActionsProps> = ({
  selectedIds,
}): JSX.Element => {
  const mode = useMode();
  const { session } = useSessionInfo();

  return (
    <>
      {session?.companyProfile?.id &&
        PREMIUM_COMPANY_IDS.includes(session.companyProfile.id) && (
          <PortalWithState closeOnOutsideClick closeOnEsc>
            {({ openPortal, closePortal, portal }) => (
              <>
                <Button
                  variant="outline"
                  disabled={!selectedIds.length}
                  icon="add-new"
                  onClick={openPortal}
                >
                  Create Jobs
                </Button>
                {portal(
                  <AddAssemblyJobsModal
                    backflowAssemblyIds={selectedIds}
                    onClose={closePortal}
                  />
                )}
              </>
            )}
          </PortalWithState>
        )}

      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, portal }) => (
          <>
            <Button
              variant="outline"
              disabled={!selectedIds.length}
              icon="mail"
              onClick={openPortal}
            >
              Send Notice
            </Button>
            {portal(
              <SendNoticeModal
                selectedIds={selectedIds}
                onClose={closePortal}
              />
            )}
          </>
        )}
      </PortalWithState>

      {mode === 'water-supplier' && (
        <PortalWithState closeOnOutsideClick closeOnEsc>
          {({ openPortal, closePortal, portal }) => (
            <>
              <Button
                variant="outline"
                disabled={!selectedIds.length}
                icon="calendar"
                onClick={openPortal}
              >
                Set Test Anniversary
              </Button>
              {portal(
                <TestAnniversaryModal
                  selectedIds={selectedIds}
                  onClose={closePortal}
                />
              )}
            </>
          )}
        </PortalWithState>
      )}
    </>
  );
};

export default AssembliesActions;
